import { ComponentProps, FC } from "react";
import styled from "styled-components";
import { IconButton } from "./IconButton";

const StyledIconClusterButton = styled(IconButton)`
  border-radius: 0px;
  :hover:not(:disabled) {
    box-shadow: var(--elevation-0);
  }
`;

const StyledIconCluster = styled.div`
  ${StyledIconClusterButton}:first-child {
    border-radius: 3px 0px 0px 3px;
  }

  ${StyledIconClusterButton}:last-child {
    border-radius: 0px 3px 3px 0px;
  }
`;

type IconClusterProps = {
  /** List of props to pass to each IconButton. */
  icons: ComponentProps<typeof IconButton>[];
};

export const IconCluster: FC<IconClusterProps> = ({ icons }) => {
  return (
    <StyledIconCluster>
      {icons.map((icon) => (
        <StyledIconClusterButton key={icon.iconName} {...icon} />
      ))}
    </StyledIconCluster>
  );
};
